<script>
import Swal from '../../../js/sweetalert2.min.js';

export default {
    beforeMount(){
        this.redirect();
    },
    methods: {
        redirect: function(e){
            var msg = "'네이버 아이디로 가입' 으로 이미 가입한 계정이 있습니다.";
            Swal.showLoading();
            swal(msg, {
                buttons: false,
                timer: 3000
            });
            Swal.close();
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/user/MsgExistNaver.vue